<template>
  <div v-if="detail != ''" class="container">
    <h3>{{ "商品名称：" + detail.brand_name }}</h3>
    <ul>
      <li>
        <label>项目名称：</label>
        <p>{{ detail.project_name }}</p>
      </li>
      <li>
        <label>网点名称：</label>
        <p>{{ detail.device_name }}</p>
      </li>
      <li>
        <label>厂商：</label>
        <p v-show="detail.firm_id == 1">易触</p>
        <p v-show="detail.firm_id == 2">华屹1</p>
        <p v-show="detail.firm_id == 3">华屹2</p>
        <p v-show="detail.firm_id == 4">卡游</p>
      </li>
      <li>
        <label>销售类型：</label>
        <p v-show="detail.sale_type == 1">非热销</p>
        <p v-show="detail.sale_type == 2">热销</p>
      </li>
      <li>
        <label>创建时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>修改时间：</label>
        <p>{{ detail.update_time }}</p>
      </li>
      <li>
        <label>网点总库存：</label>
        <p>{{ detail.inventory }}</p>
      </li>
      <li>
        <label>调入：</label>
        <p>{{ detail.allocation_in }}</p>
      </li>
      <li>
        <label>调出：</label>
        <p>{{ detail.allocation_out }}</p>
      </li>
      <li>
        <label>补货／上新：</label>
        <p>{{ detail.work_order }}</p>
      </li>
      <li>
        <label>撤柜退回：</label>
        <p>{{ detail.all_return }}</p>
      </li>
      <li>
        <label>货品退回：</label>
        <p>{{ detail.part_return }}</p>
      </li>
      <li>
        <label>理论库存：</label>
        <p>{{ detail.theory }}</p>
      </li>
      <li>
        <label>现有库存：</label>
        <p>{{ detail.real_inventory }}</p>
      </li>
      <li>
        <label>差异：</label>
        <p>{{ detail.check_diff }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: "",
      images: []
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
      //   console.log(this.detail);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 3.2%;
  h3 {
    font-size: 20px;
    margin: 20px 0;
  }
  ul {
    li {
      display: inline-block;
      width: 33.3%;
      vertical-align: top;
      margin-bottom: 20px;
      label,
      p {
        display: inline-block;
        vertical-align: top;
      }
      .imgStyle {
        display: inline-block;
        vertical-align: top;
      }
      img {
        width: 100px;
        height: 100px;
        border: 1px solid #ededed;
        object-fit: cover;
      }
    }
  }
}
</style>
